import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSessionStorage, useIsPtiEnabled } from '~/modules/common/hooks';
import { ResourceRequestDeleteActions } from '~/modules/resourcing/common/components';
import { useGetResourceRequestFilter } from '~/modules/resourcing/common/hooks/useGetResourceRequestFilter';
import useDeleteResourceRequestHandler, {
  updateCache as updateDeleteCache
} from '~/modules/resourcing/common/hooks/useDeleteResourceRequestHandler';

export const ResourceRequestPeriodDeleteDialog = ({
  resourceRequest,
  closeRemoveRequestDialog,
  showRemoveRequestDialog,
  isResourceActualModeEnabled
}) => {
  const isPtiEnabled = useIsPtiEnabled();

  const filter = useGetResourceRequestFilter();
  const { storedValue: resourceRequestsQueryVariables } = useSessionStorage(
    'RESOURCE-REQUESTS-QUERY-VARIABLES',
    null
  );

  const { deleteResourceRequestFromProject } = useDeleteResourceRequestHandler({
    isResourceActualModeEnabled,
    cacheUpdateFunctions: isPtiEnabled
      ? [
          updateDeleteCache({
            projectUri: resourceRequest.projectUri,
            resourceRequestsQueryVariables: resourceRequestsQueryVariables
              ? {
                  ...resourceRequestsQueryVariables,
                  projectUri: resourceRequest.projectUri
                }
              : null,
            request: resourceRequest,
            filter,
            isResourceActualModeEnabled
          })
        ]
      : []
  });

  const onDeleteRequestClick = useCallback(() => {
    closeRemoveRequestDialog();
    deleteResourceRequestFromProject({
      resourceRequestsQueryVariables: resourceRequestsQueryVariables
        ? {
            ...resourceRequestsQueryVariables,
            projectUri: resourceRequest.projectUri
          }
        : null,
      request: resourceRequest
    });
  }, [
    closeRemoveRequestDialog,
    deleteResourceRequestFromProject,
    resourceRequest,
    resourceRequestsQueryVariables
  ]);

  return (
    <ResourceRequestDeleteActions
      showRemoveRequestDialog={showRemoveRequestDialog}
      closeRemoveRequestDialog={closeRemoveRequestDialog}
      onDeleteRequestClick={onDeleteRequestClick}
    />
  );
};

ResourceRequestPeriodDeleteDialog.propTypes = {
  resourceRequest: PropTypes.object.isRequired,
  closeRemoveRequestDialog: PropTypes.func.isRequired,
  showRemoveRequestDialog: PropTypes.bool.isRequired,
  isResourceActualModeEnabled: PropTypes.bool
};

export default ResourceRequestPeriodDeleteDialog;
